export const FEDERAL_TAX_RATES_TYPE = {
	AllAwards: "AllWards",
	CurrentAwards: "CurrentAwards",
	ByYear: "ByYear",
	ByVest: "ByAwardVest"
}

export const REPORT_TYPE = {
  AWARD_SUMMARY_AWARD_DATE: "award",
  AWARD_SUMMARY_CALENDAR_YEAR: "calendar-year",
  AWARD_SUMMARY_COMPENSATION_YEAR: "comp-year",
  AWARD_SUMMARY_CUSTOM: "custom",
  AWARD_SUMMARY_OPTION: "option",
  DETAIL_TAX_EXCEL: "DETAIL_TAX_EXCEL",
  DETAIL_TAX_PDF: "DETAIL_TAX_PDF",
  EMPLOYEE_EQUITY_PDF: "EMPLOYEE_EQUITY_PDF"
}

export const DOWNLOAD_TYPE = {
  EXCEL: "excel",
  PDF: "pdf"
}

export const DIALOGS = {
  ReviewAwardDialog: "ReviewAwardDialog",
  UnvestedAwardDetailsDialog: "UnvestedAwardDetailsDialog",
  VestedAwardDetailsDialog: "VestedAwardDetailsDialog"
}

export const COMPONENT_IDS = {
  NextVest: "next-vest",
  UnacceptedAward: "unacceptedAwardSection",
  VestingSummary: "vestingSummaryHeading",
  FirstBrokerCard: "BrokerCard_0"
}

export const ARIA_TABLE_ROLE = {
  Cell: "cell",
  ColumnHeader: "columnheader",
  Row: "row",
  RowGroup: "rowgroup",
  RowHeader: "rowheader",
  Table: "table"
}

export function convertHtmlBoldToStencilBold(text) {
  text = text.replaceAll("<b>", "<strong>");
  return text.replaceAll("</b>", "</strong>");
}

export function setFocusToDashboard() {
  var element = document.getElementById(COMPONENT_IDS.UnacceptedAward);
  if (element) {
    element.focus();
  } else {
    document.getElementById(COMPONENT_IDS.VestingSummary)?.focus();
  }
}

export function setLocationOfPriorFocus(refFrom=null, idFrom=null) {
  if (refFrom != null) {
    return {refBack: refFrom};
  } else if (idFrom != null) {
    return {idBack: idFrom};
  }
  return {};
}
